import type { ReactElement } from "react";

/**
 * Sits between the prompt and the footer so the message lands where the eye
 * already is after a failed send, rather than as a toast that has to be hunted
 * for. `role="alert"` because it appears in response to an action the user just
 * took and nothing else moves focus.
 */
export function ComposerPromptLengthValidation({
  message,
}: {
  readonly message: string | null;
}): ReactElement | null {
  if (!message) return null;

  return (
    <p
      role="alert"
      className="px-3 pb-2 text-xs text-destructive sm:px-4"
      data-chat-composer-validation="prompt-length"
    >
      {message}
    </p>
  );
}
